"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _q = _interopRequireDefault(require("q"));

var _react = _interopRequireDefault(require("react"));

var _underscore = require("underscore");

var _validateUpgradeData = _interopRequireDefault(require("ui-addon-upgrades/_core/common/data/upgradeData/validateUpgradeData"));

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var _createUpgradeData = require("ui-addon-upgrades/_core/common/data/upgradeData/createUpgradeData");

var _meetingHelpers = require("ui-addon-upgrades/_core/common/api/meetingHelpers");

var _didUpgradeDataChange = _interopRequireDefault(require("ui-addon-upgrades/_core/common/data/upgradeData/didUpgradeDataChange"));

var connectUpgradeData = function connectUpgradeData(Component, upgradeSource) {
  var UpgradeDataHOC =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(UpgradeDataHOC, _React$Component);

    function UpgradeDataHOC(props) {
      var _this;

      (0, _classCallCheck2.default)(this, UpgradeDataHOC);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UpgradeDataHOC).call(this, props));
      _this.state = {
        renderBlockingUpgradeData: {},
        lazyLoadedUpgradeData: {}
      };
      return _this;
    }

    (0, _createClass2.default)(UpgradeDataHOC, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.mounted = true;
        var _this$props = this.props,
            upgradeData = _this$props.upgradeData,
            allowModal = _this$props.allowModal;

        if (allowModal) {
          (0, _meetingHelpers.prefetchMeetingData)();
        }

        if (!upgradeData || !upgradeSource) {
          return _q.default.Promise.resolve();
        }

        return this.wrapUpgradeData();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        // Re-wrap upgrade data if the upgrade data has changed
        // Note that we dont gate this in shouldComponentUpdate because
        // we'd have to do checks for the state changing as well which might
        // get a bit messy
        if ((0, _didUpgradeDataChange.default)(prevProps.upgradeData, this.props.upgradeData)) {
          this.wrapUpgradeData();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: "wrapUpgradeData",
      value: function wrapUpgradeData() {
        var _this2 = this;

        var upgradeData = this.props.upgradeData;
        return (0, _createUpgradeData.createRenderBlockingUpgradeData)(upgradeData, upgradeSource, this.props).then(function (renderBlockingUpgradeData) {
          // Since this is in a promise handler, it's possible the component has unmounted in that time
          // Will cause a warning if we setState on the unmounted component
          // See: https://github.com/facebook/react/issues/3417
          if (_this2.mounted) {
            _this2.setState({
              renderBlockingUpgradeData: renderBlockingUpgradeData
            });
          }

          return renderBlockingUpgradeData;
        }).then(function (renderBlockingUpgradeData) {
          return (0, _createUpgradeData.createLazyLoadedUpgradeData)(renderBlockingUpgradeData, upgradeSource, _this2.props).then(function (lazyLoadedUpgradeData) {
            if (_this2.mounted) {
              _this2.setState({
                lazyLoadedUpgradeData: lazyLoadedUpgradeData
              });
            }

            return lazyLoadedUpgradeData;
          });
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            renderBlockingUpgradeData = _this$state.renderBlockingUpgradeData,
            lazyLoadedUpgradeData = _this$state.lazyLoadedUpgradeData;

        if (!(0, _underscore.isEmpty)(renderBlockingUpgradeData)) {
          var isValid = (0, _validateUpgradeData.default)(renderBlockingUpgradeData);
          var newProps = (0, _extends2.default)({}, this.props, {
            upgradeData: (0, _extends2.default)({}, renderBlockingUpgradeData, lazyLoadedUpgradeData)
          });

          if (!isValid) {
            return null;
          }

          return _react.default.createElement(Component, newProps);
        }

        return null;
      }
    }]);
    return UpgradeDataHOC;
  }(_react.default.Component);

  UpgradeDataHOC.defaultProps = {
    allowModal: true
  }; // mostly for decorators like promptable that complain

  var requiredComponentPropTypes = Component.propTypes ? (0, _underscore.pick)(Component.propTypes, ['onConfirm', 'onReject']) : {};
  UpgradeDataHOC.propTypes = (0, _extends2.default)({}, requiredComponentPropTypes, _upgradeDataPropsInterface.upgradePropsInterface);
  return UpgradeDataHOC;
};

var _default = connectUpgradeData;
exports.default = _default;
module.exports = exports.default;